{
  "name": "angular-app",
  "version": "26.526.0",
  "scripts": {
    "ng": "ng",
    "prestart": "npm install",
    "start": "ng serve --port 7070",
    "build": "ng build --base-href=./",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.14",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.14",
    "@angular/compiler": "^19.2.14",
    "@angular/core": "^19.2.14",
    "@angular/forms": "^19.2.14",
    "@angular/platform-browser": "^19.2.14",
    "@angular/platform-browser-dynamic": "^19.2.14",
    "@angular/router": "^19.2.14",
    "devextreme": "24.1.6",
    "devextreme-angular": "24.1.6",
    "devextreme-schematics": "^1.2.16",
    "exceljs": "3.10.0",
    "file-saver-es": "2.0.5",
    "jspdf": "^2.5.2",
    "jspdf-autotable": "^3.5.23",
    "luxon": "^3.3.0",
    "tslib": "^2.2.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.15",
    "@angular-eslint/builder": "^20.1.1",
    "@angular-eslint/eslint-plugin": "^20.1.1",
    "@angular-eslint/eslint-plugin-template": "^20.1.1",
    "@angular-eslint/schematics": "^20.1.1",
    "@angular-eslint/template-parser": "^20.1.1",
    "@angular/cli": "^19.2.15",
    "@angular/compiler-cli": "^19.2.14",
    "@types/jasmine": "^4.3.0",
    "@types/node": "^20.10.4",
    "@typescript-eslint/eslint-plugin": "^7.2.0",
    "@typescript-eslint/parser": "^7.2.0",
    "devextreme-cli": "latest",
    "devextreme-themebuilder": "24.1.6",
    "eslint": "^8.57.0",
    "jasmine-core": "^4.5.0",
    "karma": "~6.3.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.0.3",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^1.7.0",
    "typescript": "^5.8.3"
  }
}
